import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { getFirebaseStorage } from '../firebase/config';

const MAX_BYTES = 2 * 1024 * 1024;

export async function uploadStorageImage(storagePath, file) {
  if (!file || !file.size) {
    throw new Error('No file selected');
  }
  if (file.size > MAX_BYTES) {
    throw new Error('Image must be 2 MB or smaller');
  }
  if (!file.type.startsWith('image/')) {
    throw new Error('Please choose an image file');
  }
  const ext = (file.name.split('.').pop() || 'png').replace(/[^a-zA-Z0-9]/g, '') || 'png';
  const path = `${storagePath}.${ext}`;
  const storage = getFirebaseStorage();
  const storageRef = ref(storage, path);
  await uploadBytes(storageRef, file, { contentType: file.type });
  return getDownloadURL(storageRef);
}

/**
 * Upload a marketing image (portfolio logo, service icon, etc.).
 * @param {string} pathPrefix e.g. "portfolio/abc123/logo" → stored under website/portfolio/abc123/logo.ext
 * @param {File} file
 * @returns {Promise<string>} download URL
 */
export async function uploadWebsiteImage(pathPrefix, file) {
  return uploadStorageImage(`website/${pathPrefix}`, file);
}

export function openPortfolioOrSite(portfolioItem) {
  const u = (portfolioItem?.url || '').trim();
  if (u && /^https?:\/\//i.test(u) && u !== '#') {
    window.open(u, '_blank', 'noopener,noreferrer');
    return;
  }
  const base = typeof window !== 'undefined' ? window.location.origin : '';
  window.open(`${base}/portfolio`, '_blank', 'noopener,noreferrer');
}
